var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCf = function SvgIconCf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.54 6.26A12.03 12.03 0 0 0 15.13.412l-.522 5.848zM1.459 6.26h7.932L8.87.412A12.03 12.03 0 0 0 1.46 6.26"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#6DA544"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.608 12.002v5.739h7.933C23.47 16.036 24 14.08 24 12zM9.391 12H0c0 2.08.529 4.035 1.46 5.74H9.39z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.459 17.74a12.03 12.03 0 0 0 7.41 5.848l.522-5.115zM15.13 23.588a12.03 12.03 0 0 0 7.41-5.848l-7.932.734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.608 18.474 7.933-.734h-7.933zM9.391 17.74H1.46l7.932.733z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 0c-1.083 0-2.132.145-3.13.414v23.173c.998.27 2.047.413 3.13.413 1.084 0 2.133-.144 3.131-.413V.414A12 12 0 0 0 12.001 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m6.454 2.61.324.996h1.048l-.848.615.324.997-.848-.616-.847.616.324-.997-.848-.615h1.048z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconCf;